import React from 'react';

const AplicacionesLambrin = () => {
  return (
    <section className="pt-30 why-choose-style1">
      <div className="container">
        <div className="row mt-n1-9">
          {/* Imagen y texto flotante */}
          <div className="col-lg-6 mt-1-9">
            <div className="text-center position-relative">
              <img src="/assets/img/productos/muro-lambrin-sintetico/muro-lambrin-sintetico-aplicaciones.jpg" alt="Lambrín Sintético" />
              <div className="why-choose-box d-none d-sm-block">
                <h5 className="text-white h4">Para Interiores y Exteriores</h5>
                <span className="text-white opacity9">Lambrín Sintético</span>
              </div>
            </div>
          </div>

          {/* Contenido textual */}
          <div className="col-lg-6 mt-1-9">
            <div className="ps-xl-5">
              {/* Título */}
              <div className="mb-5">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Aplicaciones del Lambrín Sintético</span>
                <h2 className="mb-0 display-5 font-weight-800">El lambrín sintético es una opción versátil para múltiples usos en diseño y construcción:</h2>
              </div>

              {/* Primera razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-arrow display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Revestimientos de Muros Interiores:</h4>
                  <p className="mb-0">Añade un toque contemporáneo y sofisticado a oficinas, salas de estar y espacios comerciales.</p>
                </div>
              </div>

              {/* Segunda razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-arrow display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Recubrimientos de Fachadas Exteriores:</h4>
                  <p className="mb-0">Protege tus muros con un material resistente a la intemperie que mantiene su atractivo visual a lo largo del tiempo</p>
                </div>
              </div>

              {/* Tercera razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-arrow display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Detalles Decorativos:</h4>
                  <p className="mb-0">Úsalo para crear paredes de acento en hoteles, restaurantes y proyectos residenciales.</p>
                </div>
              </div>

              {/* Cuarta razón */}
              <div className="d-flex mt-1-9">
                <div className="flex-shrink-0 me-4">
                  <i className="icon-arrow display-12 text-primary"></i>
                </div>
                <div className="flex-grow-1">
                  <h4 className="h5">Espacios Comerciales y Públicos:</h4>
                  <p className="mb-0">Aporta durabilidad y estética a locales, oficinas y áreas de alto tránsito.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AplicacionesLambrin;
